// Layout.jsx
import React, { useState } from "react";
import Header from "../../commonComponents/Header";
import Sidebar from "../../commonComponents/Sidebar";
import { Outlet } from "react-router";
import { CommunityProvider } from "../../config/CommunityContext";
import { FollowOrganizationProvider } from "../../config/FollowOrganizationContext";
import { UserProvider } from "../../config/userContext";
const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(prev => !prev);
  };

  return (
    <div className="layout-wrapper">
      <CommunityProvider>
      <FollowOrganizationProvider>
        <UserProvider>
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-outer container-fluid d-flex">
        {/* Sidebar */}
        <div
          className={`side-nav-dh ${isSidebarOpen ? "show-sidebar" : "hide-sidebar"}`}
          onClick={() => setIsSidebarOpen(false)} // close on outside click (optional)
        >
          <Sidebar />
        </div>

        {/* Main Panel */}
        <div className="main-panel flex-grow-1">
          <Outlet />
        </div>
      </div>
      </UserProvider>
      </FollowOrganizationProvider>  
      </CommunityProvider>
    </div>
  );
};

export default Layout;
